export const hu = {
    LEFT: 'Bal: Mozgás az előző nap.',
    RIGHT: 'Jobbra: ugrás a következő nap.',
    DOWN: 'Le: ugrás a következő sorban. | | : A Mozgás az előző sorban.',
    UP: 'PgUp: Lépés az előző hónapban.',
    PGUP: 'PgDown: lépjen a következő hónapban.',
    PGDOWN: 'Home: ugrás az előző évben.',
    HOME: 'End: ugrás a következő évben.',
    END: 'Esc/Ma/Közel van: közel a naptár.',
    ESC: 'Billentyűzet Utasítások'
};
